import { getApiBaseUrl } from "../config/env";

/**
 * POST /api/save-the-date
 * @param {{
 *   name: string;
 *   email: string;
 *   plusOne?: boolean;
 *   plusOneName?: string;
 *   plusOneEmail?: string;
 * }} payload
 */
export async function postSaveTheDate(payload) {
  const base = getApiBaseUrl();
  const url = `${base}/api/save-the-date`;

  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    let message = `Something went wrong (${res.status}). Please try again.`;
    const text = await res.text();
    if (text) {
      try {
        const data = JSON.parse(text);
        if (typeof data.message === "string") message = data.message;
        else if (typeof data.error === "string") message = data.error;
      } catch {
        if (text.length < 200) message = text;
      }
    }
    throw new Error(message);
  }

  const contentType = res.headers.get("content-type") || "";
  if (contentType.includes("application/json")) {
    return res.json();
  }
  return {};
}
